<div mat-dialog-title>
  {{data.title | translate}}
</div>
<div class="mb-3" mat-dialog-content>
  {{data.message | translate}}
</div>
<div mat-dialog-actions>
  <button class="ml-auto btn btn-sm btn-danger" style="width: 40%;" (click)="cancel()" *ngIf="data.negative_button">
    {{data.negative_button | translate}}
  </button>
  <button class="ml-1 btn btn-sm btn-info" style="width: 40%;" [mat-dialog-close]="{flag:1}"
    *ngIf="data.positive_button">
    {{data.positive_button | translate}}
  </button>
</div>